import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { UserAuth } from '../user/user.auth';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly userAuth: UserAuth
  ) {}
  //eslint-disable-next-line
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userSignedIn = JSON.parse(sessionStorage.getItem(this.userAuth.STORAGE_KEY));
    //eslint-disable-next-line
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              // MV-20341 - GLiles: We thought a status of zero was associated with network timeout but that is not the case
              // Zero is for "Unknown Error". Other calls fall into this category. For instance, I see it for 404 not found
              // statuses. Why? I have no idea. Also a 504 Gateway Timout can occur when the network is down. For that reason,
              // I am commenting this out. It does not fix the problem. We have no reliable way of knowing is the network is down.
              //case 0:
              //{
              //const options = { timeOut: 0 };
              //this.notificationService.onFail(
              //`One of the application servers is offline. Try refreshing your browser or contact system administration.`,
              //options
              //);
              //}
              //break;
              case 401:
              case 403:
                {
                  // gliles - OLPTC-4339 & 5311 - KLUDGE - please remove the 403 case above and this code once IMS/PaaS services is
                  //          sending proper HTTP status based on if no token or invalid token (401) instead of 403 user does not
                  //          have proper permission. The kludge targets an API that is called once a minute.
                  //          The theory is this API call is available to all users no matter what roles they have.
                  //          If this API returns a 403 then we no there was an invalid token used. Log the user out.
                  const goodStatusCode =
                    (err.status === 401 && err.url.indexOf('/ims/v2/users/') === -1) ||
                    (err.status === 403 &&
                      (err.url.endsWith('/entity/v1/sites/find') ||
                        err.url.indexOf('/vibe/inventory/v3/queryDevices') >= 0 ||
                        err.url.indexOf('/uicomm/getDeviceInventory') >= 0))
                      ? true
                      : false;
                  if (goodStatusCode && userSignedIn) {
                    this.userService.signout();
                    const userOrigin = this.userService.getUserAuth().userOrigin;
                    /** if user object has a userorigin(origin link) it will be redirect to the
                  origin web page where the application started from. This is applicable for fusion only, for PTC it will redirect to logout page
                  via subscribed userService.profileEvents. Fusion can sign up for same event and we can remove this code.
              **/
                    if (userOrigin) {
                      window.open(userOrigin, '_self');
                    }
                  }
                  const fusionStatusCode =
                    (err.status === 401 && err.url.indexOf('/ims/v2/users/') === -1) ||
                    (err.status === 403 && err.url.indexOf('/flowdb/api/') >= 0);
                  if (fusionStatusCode && userSignedIn) {
                    this.userService.fusionSignout();
                    this.router.navigateByUrl('logout');
                  }
                }
                break;
              case 500:
                {
                }
                break;
              case 200:
                {
                }
                break;
            }
            //TODO - log the error
          } else {
            // a client-side or network error occurred =>
            // => this should be managed by a global-error-handler
          }
        }
      )
    );
  }
}
